import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractNgModelComponent } from '../abstract-ng-model/abstract-ng-model.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-sex-radio-button',
  templateUrl: './sex-radio-button.component.html',
  styleUrls: ['./sex-radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SexRadioButtonComponent,
    },
  ],
})
export class SexRadioButtonComponent extends AbstractNgModelComponent {
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  change(data: any) {
    this.value = data;
    this.valueChange.emit(this.value);
  }
}
